import { generateUuid } from '@witmetrics/utils/uuid';
import type {
  UndecoratedOrderProduct,
  UngroupedOrderProduct,
} from '@witmetrics/utils';

export const classes = {
  table: 'pl-[69px] pr-4 pb-1.5',
  tableHeader:
    'grid grid-cols-[64px_1fr_auto] gap-3 border-b border-black/10 px-[14px] py-[9px] text-[11px] font-bold uppercase tracking-[0.04em] text-taupe-1 dark:border-white/[0.12] dark:text-mauve-3',
  tableRow:
    'grid grid-cols-[64px_1fr_auto] items-center gap-3 border-b border-black/[0.055] px-[14px] py-[11px] dark:border-white/[0.06]',
  cellQty: 'text-[13px] text-taupe-2 dark:text-mauve-2',
  cellProduct: 'text-[13px] font-medium text-taupe-3 dark:text-mauve-1',
  cellPrice:
    'whitespace-nowrap text-[13px] font-semibold text-taupe-3 dark:text-mauve-1',
};

export function formatOrderProduct(
  orderProduct: UndecoratedOrderProduct
): UngroupedOrderProduct {
  return {
    uuid: generateUuid(),
    ...orderProduct,
  };
}
